module.exports = __webpack_public_path__ + "static/media/logo.4c512146.svg";